import { render, staticRenderFns } from "./memberletter.vue?vue&type=template&id=4af0424b&"
import script from "./memberletter.vue?vue&type=script&lang=js&"
export * from "./memberletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports